import { sidemenu as sidemenuAseet, topmenu as topmenuAsset } from './assets';

const sidemenu = { key: 'sidemenu', title: 'Menu lateral', url: sidemenuAseet };
const topmenu = { key: 'topmenu', title: 'Menu superior', url: topmenuAsset };

export { sidemenu, topmenu };
export default [sidemenu, topmenu];
